<template>
  <div ref="seccionItinerarioRef" class="seccion-itinerario-container">
    
    <!-- MARIPOSAS DE FONDO -->
    <div class="mariposas-layer" aria-hidden="true">
      <img 
        v-for="(mariposa, index) in mariposas" 
        :key="index"
        :ref="el => mariposaRefs[index] = el"
        src="@/assets/mariposa.png" 
        alt="Mariposa" 
        class="mariposa-img"
        :style="mariposa.estiloInicial"
      >
    </div>

    <!-- ADORNOS ESQUINAS (SUPERIOR IZQUIERDA E INFERIOR DERECHA) -->
    <img class="adorno-top-left render-gpu" src="@/assets/esq1.png" alt="Adorno Izquierda" />
    <img class="adorno-bottom-right render-gpu" src="@/assets/esq2.png" alt="Adorno Derecha" />

    <div class="overlay-itinerario">
      
      <!-- HEADER CON MOÑO Y MÁSCARA -->
      <div ref="graphicsHeaderRef" class="header-graphics-wrapper">
        <div class="monio-full-width-wrapper">
        </div>
      </div>

      <div ref="mascaraWrapperRef" class="mascara-sub-monio-wrapper">
        <img 
          src="@/assets/coronaa.png" 
          alt="Corona Decorativa" 
          class="mascara-sub-monio-img"
        >
      </div>

      <!-- TÍTULO DE LA SECCIÓN -->
      <div ref="tituloContainerRef" class="titulo-container">
        <h2 class="itinerario-title">Itinerario <span class="letra-especial1">del Evento</span></h2>
        <p class="subtitulo-itinerario"></p>
      </div>

      <!-- FLUJO VERTICAL DEL ITINERARIO -->
      <div class="itinerario-flow">
        <div 
          v-for="(evento, index) in eventos" 
          :key="index"
          :ref="el => eventoRefs[index] = el"
          class="evento-row"
        >
          <!-- Ícono Flotante Sin Círculo -->
          <div class="icono-flotante-wrapper render-gpu">
            <img :src="evento.icono" :alt="evento.nombre" class="icono-evento" />
          </div>

          <!-- Detalles del Evento -->
          <div class="detalles-evento render-gpu">
            <span class="evento-hora">{{ evento.hora }}</span>
            <h3 class="evento-nombre">{{ evento.nombre }}</h3>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionItinerarioTimeline',
  setup() {
    const seccionItinerarioRef = ref(null)
    const graphicsHeaderRef = ref(null)
    const mascaraWrapperRef = ref(null)
    const tituloContainerRef = ref(null)
    
    const eventoRefs = ref([])
    const mariposaRefs = ref([])

    const eventos = [
      {
        nombre: 'Recepción',
        hora: '7:00 PM',
        icono: require('@/assets/co.png')
      },
      {
        nombre: 'Cena',
        hora: '8:00 PM',
        icono: require('@/assets/cena.png')
      },
      {
nombre: 'Presentación de la\nQuinceañera',        hora: '9:00 PM',
        icono: require('@/assets/co.png')
      },
     
      {
        nombre: 'Fiesta',
        hora: '10:00 PM ',
        icono: require('@/assets/disc.png')
      }
    ]

    const mariposas = [
      { estiloInicial: { top: '8%', left: '5%', width: '65px' } },
      { estiloInicial: { top: '30%', right: '4%', width: '62px' } },
      { estiloInicial: { top: '60%', left: '-4%', width: '58px' } },
      { estiloInicial: { top: '82%', right: '5%', width: '64px' } }
    ]

    onMounted(() => {
      const container = seccionItinerarioRef.value
      const adornoTL = container.querySelector('.adorno-top-left')
      const adornoBR = container.querySelector('.adorno-bottom-right')

      // TIMELINE PRINCIPAL EN SECUENCIA CONSECUTIVA
      const masterTl = gsap.timeline({
        scrollTrigger: {
          trigger: seccionItinerarioRef.value,
          start: 'top 75%',
          toggleActions: 'play none none none'
        }
      })

      // 1. Entrada de Adornos y Encabezados
      masterTl
        .from(adornoTL, { opacity: 0, scale: 0.5, x: -30, y: -30, duration: 0.5, ease: 'power2.out' })
        .from(adornoBR, { opacity: 0, scale: 0.5, x: 30, y: 30, duration: 0.5, ease: 'power2.out' }, '-=0.5')
        .from(graphicsHeaderRef.value, {
          opacity: 0,
          y: -35,
          scale: 0.95,
          duration: 0.8,
          ease: 'power2.out'
        }, '-=0.3')
        .from(mascaraWrapperRef.value, {
          opacity: 0,
          y: -20,
          scale: 0.8,
          duration: 0.6,
          ease: 'back.out(1.5)'
        }, '-=0.4')
        .from(tituloContainerRef.value, {
          opacity: 0,
          y: 25,
          duration: 0.6,
          ease: 'power3.out'
        }, '-=0.2')

      // 2. Animación Consecutiva de los Eventos del Itinerario
      // Se filtran las referencias válidas para evitar elementos nulos
      const elementosValidos = eventoRefs.value.filter(el => el !== null)

      elementosValidos.forEach((el, index) => {
        const icono = el.querySelector('.icono-flotante-wrapper')
        const detalles = el.querySelector('.detalles-evento')

        const esPar = index % 2 === 0
        const xOffset = esPar ? -50 : 50
        const rotacionInicial = esPar ? -12 : 12

        // Al encadenarse en el masterTl, cada evento espera a que termine (o casi termine) el anterior
        masterTl
          .from(icono, {
            opacity: 0,
            x: xOffset,
            y: -15,
            rotation: rotacionInicial,
            scale: 0.7,
            duration: 0.55,
            ease: 'back.out(1.4)'
          }, '-=0.2') // Inicia ligeramente antes de que finalice la animación previa para fluidez
          .from(detalles, {
            opacity: 0,
            x: -xOffset,
            y: 15,
            duration: 0.45,
            ease: 'power3.out'
          }, '-=0.35')
      })

      // 3. Flotación Continua de Mariposas (Loop Independiente)
      mariposaRefs.value.forEach((el, index) => {
        if (!el) return
        gsap.to(el, {
          y: '+=18',
          x: index % 2 === 0 ? '+=10' : '-=10',
          rotation: index % 2 === 0 ? 8 : -8,
          duration: 3 + index * 0.7,
          repeat: -1,
          yoyo: true,
          ease: 'sine.easeInOut'
        })
      })
    })

    return {
      seccionItinerarioRef,
      graphicsHeaderRef,
      mascaraWrapperRef,
      tituloContainerRef,
      eventoRefs,
      mariposaRefs,
      mariposas,
      eventos
    }
  }
}
</script>
<style scoped>
/* ==========================================
   1. CONTENEDOR PRINCIPAL
   ========================================== */
.seccion-itinerario-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(circle, #6d0a14 0%, #3e0409 100%);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;
  margin-top: -50px;
  padding-bottom: 70px;
}

.overlay-itinerario {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

/* ==========================================
   2. ADORNOS ESQUINAS (CORREGIDO)
   ========================================== */
.adorno-top-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 90px;
  height: auto;
  pointer-events: none;
  z-index: 3;
}

.adorno-bottom-right {
  position: absolute;
  bottom: 0 !important;
  right: 0 !important;
  top: auto !important;
  left: auto !important;
  width: 90px;
  height: auto;
  pointer-events: none;
  z-index: 3;
}

/* ==========================================
   3. HEADER GRÁFICO (MOÑO Y MÁSCARA)
   ========================================== */
.header-graphics-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
  position: relative;
}

.monio-full-width-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.monio-header-img {
  width: 100%;
  min-width: 100%;
  max-width: none;
  height: auto;
  display: block;
  object-fit: cover;
}

.mascara-sub-monio-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: -85px;
  margin-bottom: 20px;
  z-index: 4;
}

.mascara-sub-monio-img {
  width: 240px;
  height: auto;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15));
}

/* ==========================================
   4. TÍTULOS
   ========================================== */
.titulo-container {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.itinerario-title {
  font-family: 'ludovica', serif;
  font-size: 42px;
  color: #B08D57;
  font-weight: 500;
  margin-top:-40px;
  margin: 0;
  line-height: 1.1;
}

.letra-especial1 {
  font-family: 'Great Vibes', cursive;
  color: #B08D57;
  display: block;
  font-size: 46px;
  margin-top: -5px;
}

.subtitulo-itinerario {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  color: #6E5336;
  font-style: italic;
  margin-top: 6px;
}

/* ==========================================
   5. FLUJO DEL ITINERARIO
   ========================================== */
.itinerario-flow {
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.evento-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-bottom: 24px;
}

.icono-flotante-wrapper {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icono-evento {
  width: 66px !important;
  height: 66px !important;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(140, 28, 41, 0.15));
}

.detalles-evento {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.evento-hora {
  font-family: 'Playfair Display', serif;
  font-size: 19px !important;
  color: #B08D57;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.evento-nombre {
  white-space: pre-line; /* Hace que el \n del script genere un salto de línea real */
   font-size: 22px !important;
  font:26px 'quote', sans-serif; 
  line-height: 1.8; 
  color: #B28F60; 
  font-weight: 500;
  margin: 0;
  line-height: 1.2;
}

/* ==========================================
   6. MARIPOSAS ANIMADAS DE FONDO
   ========================================== */
.mariposas-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.mariposa-img {
  position: absolute;
  height: auto;
  opacity: 0.85;
  animation: aleteoSutil 1.8s infinite ease-in-out alternate;
  will-change: transform;
}

@keyframes aleteoSutil {
  0% { transform: scaleX(1); }
  100% { transform: scaleX(0.65); }
}

/* Hardware Acceleration Class */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}


</style>